import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
function Carousel({item}){
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? item.imageURL_List.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === item.imageURL_List.length - 1 ? 0 : prev + 1));
  };
return(
       <div className="relative w-full h-72 sm:h-96 rounded-lg overflow-hidden">
              {item.imageURL_List ? <><img
                src={item.imageURL_List[currentIndex]}
                alt={`Slide ${currentIndex + 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

              {item.imageURL_List.length > 1 && (
                <>
                  <button
                    onClick={prevSlide}
                    className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-1"
                  >
                    <ChevronLeftIcon className="w-6 h-6 text-gray-800" />
                  </button>
                  <button
                    onClick={nextSlide}
                    className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-1"
                  >
                    <ChevronRightIcon className="w-6 h-6 text-gray-800" />
                  </button>
                </>
              )} </>:<>
              <img
                src={item.imageURL}
                alt={`Slide 1}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div></>

             
              }
            </div>

)
}

export default Carousel;